import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Button } from "@mui/material";

import { useCustomerContext } from "../../../../Context/CustomerContext";
import { useTrackFsk8sEvent } from "../../events";
import { useCustomerHasPerfectScale } from "../../hooks";

interface PerfectScaleLinkProps {
  content?: string | ((customerHasPerfectScale: boolean) => string | undefined);
  href?: string;
}

const PerfectScaleLink = ({ content, href }: PerfectScaleLinkProps) => {
  const { customer } = useCustomerContext();
  const trackFsk8sEvent = useTrackFsk8sEvent();
  const customerHasPerfectScale = useCustomerHasPerfectScale();

  const handleClick = () => {
    trackFsk8sEvent("PerfectScale Link Clicked", {
      customerHasPerfectScale,
      perfectScaleTenantId: customer.perfectscale?.tenantID,
    });

    // Use setTimeout to ensure the click event is processed before opening the link
    setTimeout(() => {
      window.open(
        href ??
          (customerHasPerfectScale
            ? "https://app.perfectscale.io/account/login"
            : "https://info.perfectscale.io/intelligent-k8s-optimization?utm_source=referral&utm_medium=doit-dci&utm_campaign=dci-insights&utm_content=general-lp"),
        "_blank"
      );
    }, 100);
  };

  const getContent = () => {
    if (typeof content === "function") {
      return content(customerHasPerfectScale);
    }

    return content;
  };

  return (
    <Button onClick={handleClick} variant="contained" color="primary" startIcon={<OpenInNewIcon />}>
      {getContent() ?? (customerHasPerfectScale ? "Go to PerfectScale" : "Start a free trial")}
    </Button>
  );
};

export default PerfectScaleLink;
